import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const TrainingIntelligencePillar = () => {
  const features = [
    'Communication fundamentals',
    'Industry-specific basics',
    'Soft skills and professionalism',
    'Client-specific procedures',
    'Compliance and policy training',
    'Role readiness foundations'
  ];

  const impacts = [
    'Faster ramp-up post-placement',
    'Higher client satisfaction',
    'Fewer early failures',
    'Stronger candidate confidence'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="p-8 md:p-12 rounded-3xl bg-gradient-to-br from-gray-900/90 to-blue-900/30 border border-cyan-500/30">
          <div className="flex items-start gap-6 mb-8">
            <div className="w-20 h-20 rounded-2xl overflow-hidden shadow-lg flex-shrink-0 border border-cyan-500/30">
              <img 
                src="https://customer-assets.emergentagent.com/job_f6991d0e-ab71-4b45-956d-bb71024e7667/artifacts/43k1hzko_Engine%20Icon.png" 
                alt="Traain Engine"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
                Traain Engine
              </h2>
              <p className="text-xl text-cyan-400 font-semibold">
                Train Talent Before They Ever Start
              </p>
            </div>
          </div>

          <p className="text-lg text-gray-300 mb-8 leading-relaxed">
            Traain Engine transforms static onboarding into structured, adaptive training that prepares candidates for real work environments.
          </p>

          <div className="mb-8">
            <h3 className="text-xl font-bold text-white mb-4">Use Traain Engine to deliver:</h3>
            <div className="grid md:grid-cols-2 gap-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-cyan-400 rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-300">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-bold text-white mb-4">Impact for staffing firms:</h3>
            <div className="grid md:grid-cols-2 gap-4">
              {impacts.map((impact, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-green-400 rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-300">{impact}</span>
                </div>
              ))}
            </div>
          </div>

          <Button
            variant="outline"
            className="border-2 border-cyan-500 text-cyan-400 hover:bg-cyan-500/10 hover:border-cyan-400"
          >
            Learn More → Traain Engine
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default TrainingIntelligencePillar;